import axios from "axios";
import ReturnBox from "@/components/layout/goods/ReturnBox.vue";

export default {
  components: {
    ReturnBox,
  },
  data: () => ({
    clientName: null,
    clientPhone: null,
    clientState: null,
    clientCity: null,
    client_doc: 0,
    clientMessage: null,
    errors: [],
    response: [],
    responseTitle: null,
    responseBody: null,
    fullPage: false,
    status: null,
  }),
  methods: {
    formatString(string) {
      return string.toString().replace(/[^a-z0-9]/gi, "");
    },

    sendContact() {
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        backgroundColor: "#FFC000",
        color: "#581E9B",
        opacity: 0.9,
      });
      let clientPhone = this.formatString(this.clientPhone);

      axios
        .post(this.apiUrl + "/ContactForm", {
          client_name: this.clientName,
          client_doc: 0,
          client_phone: clientPhone,
          client_message: this.clientCity,
          message_type: this.messageId,
        })
        .then((response) => {
          this.response = response.data;
          this.status = "success";
          this.responseTitle = this.titleSuccess;
          this.responseBody = this.messageSuccess;
          console.log(response)
        })
        .catch((errors) => {
          this.response = errors.response.data;
          this.status = "error";
          this.responseTitle = this.titleError;
          this.responseBody = this.messageError;
          console.log(errors.response)
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
